export const LOCALE_NL = {
    ORDER: "Bestelling",
    INVOICE: "Factuur",
    INVOICES: "Facturen",
    CREDIT_NOTE: "Kredietnota",
    CREDIT_NOTES: "Kredietnota's",
    CREATION_DATE: "Datum van uitgifte",
    DELIVERY_DATE: "Leveringsdatum",
    DELIVERY_ADDRESS: "Leveringsadres",
    DELIVERY_COST: "Leveringskosten",
    VENDOR: "Leverancier",
    CUSTOMER: "Klant",
    ORDER_NUMBER: "Bestelnummer",
    PAYMENT_METHOD: "Betaalmethode",
    NOTE: "Opmerking",
    PRODUCT: "Artikel",
    PRODUCT_DESCRIPTION: "Beschrijving",
    PRODUCT_AMOUNT: "Hoeveelheid",
    PRODUCT_SINGLE_PRICE: "Prijs per eenheid",
    DISCOUNT: "Korting",
    TOTAL_DISCOUNTS: "Totaal korting",
    TOTAL_BEFORE_DISCOUNTS: "Totaal excl. korting",
    TAX_ABBREVIATED: "BTW.",
    TAX_AMOUNT: "Belastingbedrag",
    SPLIT_AMOUNT: "Gesplitst bedrag",
    BRUTTO: "Bruto",
    TOTAL: "Totaal",
    TOTAL_INCLUDING_VAT: "Totaal incl. BTW",
    TOTAL_EXCLUDING_VAT: "Totaal excl.",
    VAT_ID: "BTW-nr.",
    TAX_ID: "Belastingnr..",
    PAID: "Betaald",
    UNPAID_AMOUNT: "Onbetaald bedrag",
    REASON: "Reden",
    INVOICE_LINE_ITEMS_TITLE: "Artikelen bestellen",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Kredietnota's op bestelartikelen",
    OTHER_CREDIT_NOTES: "Aanpassing van de bestelling",
    REFUND_SHIPPING_COST: "Verzendkosten voor retourzending",
    REFUND_HAS_BEEN_PAID: "Restitutie ten bedrage van $VALUE is betaald.",
    REFUND_HAS_BEEN_PAID_FAILED: "Terugbetaling van een betaling van $VALUE is mislukt.",
    DOCUMENTS_FOR_ORDER: "Documenten voor bestelling",
    NO_INVOICES: "Nog geen facturen",
    NO_CREDIT_NOTES: "Nog geen kredietnota's",
    DOCUMENTS_ARE_GENERATING: "Documenten worden gegenereerd. Probeer het over enkele minuten nog eens.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "We konden geen documenten vinden voor deze bestelling. Stuur een mail naar support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC: "We konden geen documenten vinden voor deze bestelling. Stuur een mail naar de verkoper",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "We konden geen documenten vinden voor deze bestelling. Stuur een mail naar ${MAIL}",
    GIFT_CARD_LINE: "Voor deze bestelling is een vouchercode${GIFT_CARD_CODE} voor ${GIFT_CARD_AMOUNT} gebruikt",
    GIFT_CARD: "Voucher",
    REVERSAL_INVOICE: "Annuleringsfactuur",
    REVERSAL_CREDIT_NOTE: "Annulering van de kredietnota",
    DUTY: "Douanerecht",
    USED_DISCOUNTS: "Toegepaste kortingen",
    PAYMENT_AT: "Betaling op $DATE",
    REFUNDED_CREDITNOTE_AT: "Terugbetaling van de creditnota $CREDIT_NOTE op $DATE",
    REFUNDED_AT: "Terugbetaling op $DATE",
    PROCESSING_DOCUMENT: "Document wordt verwerkt",
    DOWNLOAD_DOCUMENTS_TITLE: "Download hier je documenten!",
    MAIL_INTRODUCTION: "Voor vragen kunt u contact opnemen met ${MAIL}",
    REPAYMENT_DIFFERENCE: "Terugbetalingsverschil",
    DOCUMENT_PREVIEW_BANNER: "Voorbeeld – download de PDF",
};
